import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function CalorifugeagePage() {
  const parcours = getOperationIndustrieStub('calorifugeage');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche IND-UT-103',
        },
        {
          label: 'Coups de pouce industriels',
          href: '/industrie/aides/coups-de-pouce',
          iconName: 'flame',
          hint: 'Bonification possible selon arrêté en vigueur',
        },
        {
          label: 'Chaufferie process',
          href: '/industrie/operations/chaufferie',
          iconName: 'flame',
          hint: "Cohérence globale du réseau vapeur",
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
